import React, { FC } from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { CardNotification, Button } from "@foris/avocado-suite";
import { useHistory } from "react-router-dom";
import useContextUrl from "@common/hooks/useContextUrl";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import css from "./empty-results.module.scss";

interface PropsEmpty {
  className?: string;
  dimension?: string;
  search?: string;
  isCalendarView?: boolean;
}

const EmptyResults: FC<PropsEmpty> = ({ isCalendarView, className = "" }) => {
  const { origin, scenario, workspace } = useContextUrl();
  const { homeUrl, advancedSearchUrl } = useNavigationUrl();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={cx(css.cntEmpty, isCalendarView && css.cntEmpty__calendar, className)}>
      <CardNotification
        className={css.cntEmpty_cardNotification}
        state="info"
        title={t("empty-results.title")}
        outlined={isCalendarView}
      >
        {t("empty-results.description")}
      </CardNotification>

      <div className={css.cntEmpty_actionsBtn}>
        <Button
          variant="secondary"
          onClick={() => history.push(homeUrl(workspace, scenario, origin))}
        >
          {t("empty-results.btn-home")}
        </Button>

        {origin && scenario && workspace && (
          <Button onClick={() => history.push(advancedSearchUrl())}>
            {t("empty-results.btn-advanced-search")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyResults;
